module.exports = __webpack_public_path__ + "static/sec2-0d1e379d8e7bf371d5a0c41c6a7fdd36.png";